// generated by `python -m python book-metadata`
const metadata = [
  {
    tab_color: "red",
    tab_index: 0,
    page_id: 0,
    card_count: 13,
  },
  {
    tab_color: "orange",
    tab_index: 0,
    page_id: 1,
    card_count: 25,
  },
  {
    tab_color: "orange",
    tab_index: 1,
    page_id: 2,
    card_count: 25,
  },
  {
    tab_color: "orange",
    tab_index: 2,
    page_id: 3,
    card_count: 1,
  },
  {
    tab_color: "lightgreen",
    tab_index: 0,
    page_id: 4,
    card_count: 25,
  },
  {
    tab_color: "lightgreen",
    tab_index: 1,
    page_id: 5,
    card_count: 25,
  },
  {
    tab_color: "lightgreen",
    tab_index: 2,
    page_id: 6,
    card_count: 25,
  },
  {
    tab_color: "lightgreen",
    tab_index: 3,
    page_id: 7,
    card_count: 10,
  },
  {
    tab_color: "green",
    tab_index: 0,
    page_id: 8,
    card_count: 25,
  },
  {
    tab_color: "green",
    tab_index: 1,
    page_id: 9,
    card_count: 25,
  },
  {
    tab_color: "green",
    tab_index: 2,
    page_id: 10,
    card_count: 20,
  },
  {
    tab_color: "lightblue",
    tab_index: 0,
    page_id: 11,
    card_count: 25,
  },
  {
    tab_color: "lightblue",
    tab_index: 1,
    page_id: 12,
    card_count: 25,
  },
  {
    tab_color: "lightblue",
    tab_index: 2,
    page_id: 13,
    card_count: 1,
  },
  {
    tab_color: "blue",
    tab_index: 0,
    page_id: 14,
    card_count: 25,
  },
  {
    tab_color: "blue",
    tab_index: 1,
    page_id: 15,
    card_count: 6,
  },
  {
    tab_color: "purple",
    tab_index: 0,
    page_id: 16,
    card_count: 25,
  },
  {
    tab_color: "purple",
    tab_index: 1,
    page_id: 17,
    card_count: 8,
  },
  {
    tab_color: "black",
    tab_index: 0,
    page_id: 18,
    card_count: 25,
  },
  {
    tab_color: "black",
    tab_index: 1,
    page_id: 19,
    card_count: 5,
  },
  {
    tab_color: "gold",
    tab_index: 0,
    page_id: 20,
    card_count: 25,
  },
  {
    tab_color: "gold",
    tab_index: 1,
    page_id: 21,
    card_count: 25,
  },
];

function compute_offsets() {
  let card_counts = metadata.map((m) => m.card_count);
  let acc = 0;
  let res = [0];
  for (let i = 0; i < card_counts.length; i++) {
    acc += card_counts[i];
    res.push(acc);
  }
  return res;
}

const offsets = compute_offsets();

export { metadata, offsets };
